import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import PiPopupWindowPreview from "../../features/previews/components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../../features/previews/components/PiPopupHeaderBar";
import HideClickIndicatorNodePreview from "../../features/sequence/node_previews/HideClickIndicatorNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";

export interface IHideClickIndicator extends Interaction {
  propGuid: string;
  tag: string;
}

export const hideClickIndicatorInteraction = (): InteractionFactoryEntity => {
  const view = (
    <PiPopupWindowPreview
      size="medium"
      body={<div>Hides the click indicator for a prop.</div>}
      header={<PiPopupHeaderBar interactionType={InteractionType.HideClickIndicator} title="Hide Click Indicator" />}
    />
  );

  const create = (): IHideClickIndicator => {
    return {
      id: GetNewGuid(),
      name: "Hide Click Indicator",
      type: InteractionType.HideClickIndicator,
      propGuid: "",
      tag: "",
      properties: [],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IHideClickIndicator => {
    return interaction as IHideClickIndicator;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IHideClickIndicator => {
    const original = interaction as IHideClickIndicator;

    return {
      ...original,
      id: GetNewGuid(),
      properties: original.properties?.map((property) => ({ ...property })) ?? [],
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    take: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IHideClickIndicator;
    const warnings: string[] = [];

    return warnings;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const converted = interaction as IHideClickIndicator;
    const searchableStrings: string[] = [
      converted.name,
      converted.tag,
    ];

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "Hide Click Indicator";

  const validateError = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    const converted = interaction as IHideClickIndicator;
    const errors: string[] = [];

    if (!converted.propGuid || converted.propGuid === "") {
      errors.push("No prop selected.");
    }

    return errors;
  };

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <HideClickIndicatorNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
